import { render, staticRenderFns } from "./ThankyouLetterReadOnly.vue?vue&type=template&id=1bfc8dfe&"
import script from "./ThankyouLetterReadOnly.vue?vue&type=script&lang=js&"
export * from "./ThankyouLetterReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports